var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal portal-modal",
      attrs: {
        id: _vm.id,
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          class: {
            "modal-dialog-scrollable": _vm.modalDialogScrollable,
            "modal-xl": _vm.modalExtraLarge,
            "modal-lg": _vm.modalLarge,
            "modal-dialog-centered": _vm.centered,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content data-load",
              class: { "sk-loading": _vm.showSpinner },
            },
            [
              _vm.showSpinner ? _c("sk-spinner") : _vm._e(),
              _c(
                "div",
                { staticClass: "modal-header" },
                [
                  _vm._t("title", function () {
                    return [
                      _c("h4", { staticClass: "modal-title" }, [
                        _vm._v(_vm._s(_vm.modalTitle)),
                      ]),
                    ]
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.closeButtonClicked },
                    },
                    [_vm._m(0)]
                  ),
                ],
                2
              ),
              _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2),
              _vm.showPrimaryFooterButton || _vm.showSecondaryFooterButton
                ? _c(
                    "div",
                    { staticClass: "modal-footer" },
                    [
                      _vm.showSecondaryFooterButton
                        ? _c(
                            "a",
                            {
                              staticClass: "secondary-button",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.secondaryButtonClicked.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.secondaryButtonTranslation))]
                          )
                        : _vm._e(),
                      _c("vue-button", {
                        staticClass: "btn-primary",
                        attrs: {
                          title: _vm.primaryButtonTranslation,
                          loading: _vm.loadingPrimaryFooterButton,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.primaryButtonClicked.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { attrs: { "aria-hidden": "true" } }, [
      _c("i", { staticClass: "fas fa-times close-icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }